import { useContext, useEffect, useState } from "react";
import { CartContext, SettingsContext } from "../../App";
import Product from "./Product";
import Label from "../Label";

function Products({ products, timerActive, updateQty, groupByCustomer = false }) {
	const { settings } = useContext(SettingsContext);
	const { cart } = useContext(CartContext);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const enableFlow = settings?.orders?.enable_flow ?? settings?.selfordering?.enable_flow;

	useEffect(() => {
		if (enableFlow == 1) {
			let arr = JSON.parse(JSON.stringify(products));
			arr.sort(function (a, b) {
				return parseInt(a.flow) - parseInt(b.flow);
			});
			setFilteredProducts(arr);
		} else setFilteredProducts(products);
	}, [products, enableFlow]);

	// round esauriti: i prodotti AYCE non sono più ordinabili, quelli a pagamento o esclusi sì
	const roundsExhausted = cart.rounds?.exhausted == true;
	const isBlocked = (product) =>
		!product.exclude_from_ayce &&
		((timerActive && !(settings.selfordering?.disable_timer_for_priced == 1 && product.price > 0)) || (roundsExhausted && product.price == 0));

	let prevFlow = null;
	function printFlow(flow) {
		if (flow != prevFlow) {
			prevFlow = flow;
			return <div className="cart-flow-line"><Label number={188} /> {flow}</div>;
		}
	}

	const parseNicknames = (rawNicknames) => {
		if (!Array.isArray(rawNicknames)) return [];
		return rawNicknames
			.map((item) => ({
				nickname: item?.nickname ? String(item.nickname).trim() : "",
				qty: parseInt(item?.qty ?? 0),
			}))
			.filter((item) => item.nickname && item.qty > 0);
	};

	const getNicknameLabel = (nicknames) => {
		const parsed = parseNicknames(nicknames);
		if (parsed.length === 0) return null;
		return parsed.map((item) => `${item.nickname} x${item.qty}`).join(", ");
	};

	const expandProductsByNickname = (items) =>
		items.flatMap((item) => {
			const nicknames = parseNicknames(item?.nicknames);
			if (nicknames.length === 0) {
				return [
					{
						...item,
						displayQty: item.qty,
						nickname: null,
						nicknameLabel: null,
					},
				];
			}
			return nicknames.map((nicknameItem) => ({
				...item,
				displayQty: nicknameItem.qty,
				nickname: nicknameItem.nickname,
				nicknameLabel: nicknameItem.nickname,
			}));
		});

	const groupByNickname = (items) => {
		const map = new Map();
		for (const item of expandProductsByNickname(items)) {
			const label = item.nicknameLabel || "Cliente";
			if (!map.has(label)) map.set(label, []);
			map.get(label).push(item);
		}
		return Array.from(map.entries());
	};

	const renderProducts = (items) =>
		items.map((product, i) => (
			<div key={i}>
				{printFlow(product.flow)}
				<Product
					product={product}
					timerActive={timerActive}
					updateQty={updateQty}
					showNickname={!groupByCustomer}
					displayQty={product.displayQty}
					nickname={product.nickname}
					nicknameLabel={groupByCustomer ? null : getNicknameLabel(product.nicknames)}
				/>
			</div>
		));

	const renderGroupedProducts = (items) =>
		groupByNickname(items).map(([label, groupedItems]) => {
			prevFlow = null;
			return (
				<div key={label} className="cart-group">
					<div className="cart-group-title">{label}</div>
					{renderProducts(groupedItems)}
				</div>
			);
		});

	return (
		<>
			{cart.allyoucaneat == 1 && (settings.selfordering?.disable_timer_for_priced == 1 || filteredProducts.some((p) => p.exclude_from_ayce) || roundsExhausted) ? (
				<>
					<h5 className="mt-3 mb-0">Puoi ordinare</h5>
					<div>
						{groupByCustomer
							? renderGroupedProducts(filteredProducts.filter((product) => !isBlocked(product)))
							: renderProducts(filteredProducts.filter((product) => !isBlocked(product)))}
					</div>
					{roundsExhausted ? (
						filteredProducts.some(isBlocked) && (
							<h5 className="mt-5 mb-0">
								<Label number={191} />
							</h5>
						)
					) : (
						timerActive && <h5 className="mt-5 mb-0">Attesa prossimo ordine {timerActive}</h5>
					)}
					<div>
						{groupByCustomer
							? renderGroupedProducts(filteredProducts.filter((product) => isBlocked(product)))
							: renderProducts(filteredProducts.filter((product) => isBlocked(product)))}
					</div>
				</>
			) : (
				<>
					{groupByCustomer
						? renderGroupedProducts(filteredProducts)
						: renderProducts(filteredProducts)}
				</>
			)}
		</>
	);
}

export default Products;
